import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { take } from 'rxjs/operators';
import { CustomPowershellQueriesContext } from '../../../shared/contexts/custom-powershell-queries.context';
import { CustomPowershellReport } from '../../../shared/models/generated/ziroModels';
import { BreadcrumbsService } from '../../../shared/breadcrumbs/breadcrumbs.service';

@Component({
  selector: 'ziro-custom-powershell-queries-edit',
  templateUrl: './custom-powershell-queries-edit.component.html',
  styleUrls: ['../../reporting.scss'],
  standalone: false,
})
export class CustomPowershellQueriesEditComponent implements OnInit, OnDestroy {
  private _activatedRoute = inject(ActivatedRoute);
  private _breadcrumbsService = inject(BreadcrumbsService);
  private _customPowershellReportContext = inject(CustomPowershellQueriesContext);
  private _route = inject(ActivatedRoute);

  report: CustomPowershellReport;
  isLoading = true;
  allReportNames: string[] = [];

  private _subscriptions = new Subscription();
  private _tenantId: string;

  ngOnInit(): void {
    this._tenantId = this._route.snapshot.paramMap.get('tenantId');
    const reportId = parseInt(this._activatedRoute.snapshot.params.id) || null;

    const sub = this._customPowershellReportContext.state$.pipe(take(1)).subscribe((customPowershellReports) => {
      this.allReportNames = customPowershellReports.map((report) => report.reportName.toLowerCase());
      if (reportId) {
        this.report = customPowershellReports.find((report) => report.id === reportId);
      }
      this._initBreadcrumb();
      this.isLoading = false;
    });
    this._subscriptions.add(sub);
  }

  ngOnDestroy(): void {
    this._subscriptions.unsubscribe();
    this._breadcrumbsService.clearBreadcrumbs();
  }

  private _initBreadcrumb(): void {
    const breadcrumbLabel =
      this.report?.reportName || 'tkey;reports.microsoft.custom_powershell_reports.form.breadcrumb.new_report.label';
    this._breadcrumbsService.updateBreadcrumbs([
      {
        label: 'tkey;reports.microsoft.custom_powershell_reports.title',
        url: `/reports/tenants/${this._tenantId}/custom-powershell-queries`,
        routerLink: true,
      },
      { label: breadcrumbLabel },
    ]);
  }
}
